var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgAlert = function SvgAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 17
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1055 -2084)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 210",
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    transform: "translate(1055 2084)"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 795",
    width: 7,
    height: 2,
    rx: 1,
    transform: "rotate(90 -511.5 1576)"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 797",
    width: 2,
    height: 2,
    rx: 1,
    transform: "rotate(90 -515.5 1580)"
  }))));
};

export default SvgAlert;